import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionProfesionalCreationContent } from './components/GestionProfesionalCreationContent';

export default function GestionProfesionalCreation() {

    return (
        <MainContent
            component={<GestionProfesionalCreationContent />}
            titulo={`Alta y modificación de Profesionales`}
            noBackground
            tableMaxWidth
            mainContentWhite
        />
    );

};
